// UpgradeWallModal — freemium-wall (§2 GROWTH-OS-v9: по умолчанию wall, не trial).
// Показывается ровно там, где ров продукта — попытка превысить Free-лимит
// (постов/AI-вызовов/каналов). Не блокирует молча: CTA ведёт на /billing.
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X, Lock } from 'lucide-react';
import { track } from '../utils/track';

interface Props {
  open: boolean;
  onClose: () => void;
  /** что именно упёрлось в лимит — для аналитики и текста (posts|ai|channels) */
  reason: 'posts' | 'ai' | 'channels';
  used: number;
  limit: number;
}

export function UpgradeWallModal({ open, onClose, reason, used, limit }: Props): JSX.Element | null {
  const { t } = useTranslation();
  const nav = useNavigate();

  if (!open) return null;

  const handleUpgrade = (): void => {
    // expand-intent: ещё не оплата (paid emitится сервером при webhook), но сигнал
    // намерения апгрейда — полезно для воронки Free→Paid conversion (§7a).
    track('expand', { surface: `wall_${reason}`, from_plan: 'free' });
    nav('/billing');
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose} role="dialog" aria-modal="true">
      <div className="bg-white rounded-xl max-w-md w-full p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="absolute right-3 top-3 text-brand-muted hover:text-brand-ink" onClick={onClose} aria-label={t('common.cancel')}>
          <X size={18} />
        </button>
        <div className="flex items-center gap-2 mb-2 text-brand-primary">
          <Lock size={22} />
          <h3 className="text-xl font-bold">{t(`wall.${reason}.title`)}</h3>
        </div>
        <p className="text-brand-muted mb-2">{t(`wall.${reason}.desc`)}</p>
        <p className="text-sm text-brand-muted mb-5">{t('wall.usage', { used, limit })}</p>
        <button type="button" className="btn-primary w-full" onClick={handleUpgrade}>
          {t('wall.cta')}
        </button>
        <button type="button" className="w-full mt-3 text-sm text-brand-muted hover:text-brand-ink" onClick={onClose}>
          {t('common.cancel')}
        </button>
      </div>
    </div>
  );
}
